import SelectPicker from '../../components/SelectPicker';
import FormService from '../../services/FormService';
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import {ModelListSelect} from 'vue-search-select';
import MaskedInput from 'vue-masked-input';
import Datepicker from 'vue2-datepicker'
import PrivilegeCheckModal from '../../components/PrivilegeCheckModal';

export default {
    name: "cashier_dashboard_two",
    components: {SelectPicker, Datepicker, ModelListSelect, MaskedInput, PrivilegeCheckModal},

    data() {
        return {
            details: {
                user: {
                    username: '',
                    user_role: '',
                    user_type: null,
                }
            },
            seat_class: 'yellow',
            seats_from_db: [],
            seat_class_update: [],
            selected_seat: -2,
            selected_seat_ticket: -2,
            first_floor_horizontal_rows: 0,
            first_floor_vertical_rows: 0,
            second_floor_horizontal_rows: 0,
            second_floor_vertical_rows: 0,
            first_floor: false,
            second_floor: false,
            first_floor_last_index: 0,
            selected_seats: [],
            modal_place_id: null,
            child_modal_place: null,
            required_services_sum: null,
            total_sum_for_payment: null,
            received_sum_for_payment: null,
            returned_sum_for_payment: null,
            book_button_disabled: true,
            payment_button_disabled: true,
            booking_type_booking: 1,
            booking_type_successfully_payment: 2,
            booked_place_class: [],
            already_booked_places: [],
            booked_places: [],
            men_places: [],
            women_places: [],
            update_status: false,
            successfully_booked_order: null,
            successfully_booked_passengers: [],
            passenger_birth_date: null,
            child_birth_date: null,
            current_date: null,
            discount: null,
            trip_id: null,
            type_booking: 1,
            type_buying: 2,
            privilegeCommentsShow: [],
            cashierBasket: null,
            ordered_places: [],
            personal_data: {
                full_name: null,
                pinfl: null,
                passport_number: null,
                birth_date: null,
                citizenship: null,
                address: null,
                phone: null,
                gender: null,
                child: {
                    child_status: 0,
                    child_full_name: null,
                    child_kinder_passport: null,
                    child_birth_date: null,
                    parent_permission: false,
                }
            },
            form: new FormService({
                passengers: [],
                total_price: null,
                service_amount: null,
                discount: null,
                tax: null,
                trip_id: null,
                booking_type: null,
                order_id: null,
                payment_type: null,
                privilege_id: null,
                privilege_comment: null,
                station_from: null,
                station_to: null,
                epos: {}, //alx e-pos
            }),
            countries: [],
            payment_type: 1,
            hasServices: false,
            hasPlaces: false,
            floors: [],
            privileges: [],
            services_response: [],
            services: {
                baggage_type: null,
                services: null,
            },
            placeBooked: {
                index: 1,
                class: 'booked',
            },
            waitingPayment: {
                index: 5,
                class: 'sold',
            },
            placeReserved: {
                index: 7,
                class: 'reserved',
            },
            placeSold: {
                index: 2,
                class: 'sold',
            },
            placeSeat: {
                index: 3,
                class: 'sold',
            },
            seatClass: {
                yellow: {
                    index: 1,
                    class: 'yellow',
                },
                blue: {
                    index: 2,
                    class: 'blue',
                },
                green: {
                    index: 3,
                    class: 'green',
                },
            },
            reserved_place: false,
            reserved_seconds: null,
            interval: null,
            station_from: null,
            station_to: null,
            booking_settings: {
                status: false,
                booking_fee: null,
                booking_fee_server: null,
                cashier_can_book_more_than_one: false,
                cashier_can_book_more_than_one_server: null,
                passenger_info_if_one_place_booked: false,
                passenger_info_if_more_places_booked: false,
            },
            presale_settings: {
                presale_fee: null,
                presale_hour: null,
                presale_fee_temp: 0,
            },
            seat_is_on_process_details: {
                data: {
                    username: '',
                    user_role: '',
                    type: '',
                }
            },
            seat_is_on_process_ajax_call_status: false,
            process_by_yourself: [],
            loading_states: {
                epos: false, //alx e-pos
                list: false,
                seat_is_selecting: false,
                seat_number: null,
            },
            passport_numbers: {
                numbers: [],
                index: [],
            },
            passport_number_is_not_unique: false,
            full_name_required: false,
            gender_required: false,
            trip_type: {
                0: 'Domestic',
                1: 'International',
            },
            ticket_type: 2,
            tripSeconds: null,
            alertFinishing: false,
            isFromBooked: false,

            //alx e-pos
            epos: {
                enabled: false,
                url: 'http://localhost:8347/uzpos',
                token: 'DXJFX32CN1296678504F2',
                printer_size: 80,
                device_id: null,
                company_name: null,
                company_address: null,
                company_inn: null,
                class_code_international: null,
                package_code_international: null,
                class_code_domestic: null,
                package_code_domestic: null,
                vat_percent: 0,
            },
        }
    },
    created() {
        this.isFromBooked = this.$route.params.from_booked;
        this.seat_class_update[this.seatClass.yellow.index] = this.seatClass.yellow.class;
        this.seat_class_update[this.seatClass.blue.index] = this.seatClass.blue.index;
        this.seat_class_update[this.seatClass.green.index] = this.seatClass.green.index;
        this.booked_place_class[this.placeBooked.index] = this.placeBooked.class;
        this.booked_place_class[this.waitingPayment.index] = this.waitingPayment.class;
        this.booked_place_class[this.placeSold.index] = this.placeSold.class;
        this.booked_place_class[this.placeSeat.index] = this.placeSeat.class;
        this.booked_place_class[this.placeReserved.index] = this.placeReserved.class;

        //alx e-pos
        this.getEposData();

        this.getTripdetails();
        this.getOrderedPlacesFromStore();
        this.getRequiredServicesSum();
        this.getPrivileges();
        this.getServices();
        this.getBaggageServices();
        this.getBookedPlaces();
        this.getCountries();
        this.getBookingSettings();
    },
    methods: {
        askMoneyFromPinPad(){
            axios.post('http://localhost:5000/Payment', {
                "amount": this.total_sum_for_payment * 100,
                "token": "test token",
                "ticketId": "123456"
            })
                .then(response => {
                    this.$swal(
                        this.i18n('Success'),
                        this.i18n('Operation completed successfully! The customer paid') + ' ' + this.total_sum_for_payment,
                        'success');
                })
                .catch(error => {
                    this.$swal(
                        error.response.data.message || this.i18n('An unexpected error occurred.'),
                        error.response.data.details || '',
                        'error');
                });
        },
        getBookingSettings() {
            this.$api.get('settings.booking-index')
                .then(res => {
                    if (!res.data.errors) {
                        this.booking_settings.status = true;
                        this.booking_settings.booking_fee_server = res.data.booking_fee;
                        this.booking_settings.booking_fee = this.ticket_type === 1 || this.isFromBooked ? res.data.booking_fee : this.ticket_type === 2 && this.reserved_seconds > 24 * 3600 ? res.data.booking_fee : 0;
                        this.booking_settings.cashier_can_book_more_than_one_server = res.data.cashier_reserve_seat_more_than_one_permission;
                        this.booking_settings.cashier_can_book_more_than_one = this.ticket_type === 1 && res.data.cashier_reserve_seat_more_than_one_permission === 0 ? false : this.booking_settings.cashier_can_book_more_than_one = true;
                        this.booking_settings.passenger_info_if_one_place_booked = res.data.one_seat_reserve_passenger_data;
                        this.booking_settings.passenger_info_if_more_places_booked = res.data.more_seat_reserve_passenger_data;
                    }
                });
        },
        getCountries() {
            this.$api.get('countries.all')
                .then(res => {
                    this.countries = res.data;
                });
        },
        getTripdetails() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.station_from = this.$route.params.from;
            this.station_to = this.$route.params.to;
            this.$api.get('cashier.dashboard-two-datas', {
                trip_id: this.trip_id,
                from: this.station_from,
                to: this.station_to
            }).then(res => {
                this.details = res.data;
                this.hasPlaces = true;
                this.presale_settings.presale_fee_temp = res.data.presale_hour === true ? res.data.presale_fee : 0;
                this.tripSeconds = this.details.left_seconds;
                setInterval(() => {
                    this.tripSeconds -= 1;
                }, 1000);
            });
        },
        getSeats() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.$api.get('cashier.get-seats', this.trip_id)
                .then(response => {
                    this.floors = response.data;
                    this.orderedPlacesProcess();
                    this.firstFloorSeeding();
                    this.secondFloorSeeding();
                });
        },
        getServices() {
            this.$api.get('cashier.get-services')
                .then(response => {
                    this.services_response = response.data;
                });
        },
        getPrivileges() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.$api.get('cashier.get-privileges', {
                trip_id: this.trip_id,
                from: this.station_from,
                to: this.station_to
            })
                .then(response => {
                    this.privileges = response.data;
                    this.hasServices = true;
                });
        },
        getBookedPlaces() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.$api.get('cashier.get-booked-places', this.trip_id)
                .then(response => {
                    this.booked_places = response.data.booked_seats;
                    this.men_places = response.data.men_seats;
                    this.women_places = response.data.women_seats;
                    response.data.seconds < 0 ? this.reserved_place = false : true;
                    response.data.seconds < 0 ? this.reserved_seconds = null : this.reserved_seconds = response.data.seconds;
                    this.process_by_yourself = response.data.processing_by_yourself;

                    if (this.reserved_seconds > 0) {
                        this.interval = setInterval(() => {
                            this.reserved_seconds--;
                        }, 1000);
                    }
                    this.getSeats();
                    this.process(this.process_by_yourself);
                });
        },
        getRequiredServicesSum() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.$api.get('cashier.get-required-services-sum', {trip_id: this.trip_id, from: this.station_from, to: this.station_to})
                .then(response => {
                    this.required_services_sum = response.data;
                });
        },
        getBaggageServices() {
            this.trip_id = this.$route.params['id'] ? this.$route.params['id'] : this.trip_id;
            this.$api.get('cashier.get-baggage-services', {
                trip_id: this.trip_id,
                from: this.station_from,
                to: this.station_to
            })
                .then(response => {
                    this.services.baggage_type = response.data.baggage_type;
                    this.services.services = response.data.services;
                });
        },
        async orderedPlacesProcess() {
            if (this.ordered_places && this.booked_places) {
                for (let x in this.ordered_places) {

                    if (this.booked_places[this.ordered_places[x].seat_number]) {
                        delete this.booked_places[this.ordered_places[x].seat_number];

                        await this.selectSeat(this.ordered_places[x].seat_number, true);
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.full_name = this.ordered_places[x].full_name : '';
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.passport_number = this.ordered_places[x].passport_number : '';
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.phone = this.ordered_places[x].phone : '';
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.address = this.ordered_places[x].address : '';
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.birth_date = this.ordered_places[x].birth_date : '';
                        this.selected_seats[x] ? this.selected_seats[x].personal_data.citizenship = this.ordered_places[x].citizenship : '';

                        if (this.selected_seats[x] && this.selected_seats[x].personal_data && this.selected_seats[x].personal_data.child && this.ordered_places[x].child) {
                            this.selected_seats[x].personal_data.child.child_birth_date = this.ordered_places[x].child.birth_date;
                            this.selected_seats[x].personal_data.child.child_full_name = this.ordered_places[x].child.full_name;
                            this.selected_seats[x].personal_data.child.child_kinder_passport = this.ordered_places[x].child.passport_number;
                            this.selected_seats[x].personal_data.child.child_status = 1;
                            this.selected_seats[x].personal_data.child.parent_permission = true;
                        }
                    }
                }
            }
        },
        getOrderedPlacesFromStore() {
            if (this.$store.state.cashier.basket) {
                let data = this.$store.state.cashier.basket;
                this.form.order_id = data.order_id;
                this.cashierBasket = this.$store.state.cashier.basket;
                this.trip_id = data.trip_id;
                this.ordered_places = data.booked_places;
            }
        },
        firstFloorSeeding() {
            if (this.floors.first_floor) {
                this.first_floor = true;
                this.first_floor_horizontal_rows = this.floors.first_floor.horizontal_rows;
                this.first_floor_vertical_rows = this.floors.first_floor.vertical_rows;
                this.floorSeeding(this.floors.first_floor.seat, 1);
            }
        },
        secondFloorSeeding() {
            if (this.floors.second_floor) {
                this.second_floor = true;
                this.second_floor_horizontal_rows = this.floors.second_floor.horizontal_rows;
                this.second_floor_vertical_rows = this.floors.second_floor.vertical_rows;
                this.floorSeeding(this.floors.second_floor.seat, 2, this.first_floor_last_index);
            }
        },
        floorSeeding(floor_seats, floor, last_index = null) {
            let first_x = 0, first_y = 0;
            let x_min = Number.MAX_VALUE,
                y_min = Number.MAX_VALUE,
                x_max = Number.MIN_VALUE,
                y_max = Number.MIN_VALUE;
            for (let x in floor_seats) {
                if (floor_seats[x].x > x_max) x_max = floor_seats[x].x;
                if (floor_seats[x].x < x_min) x_min = floor_seats[x].x;
                if (floor_seats[x].y > y_max) y_max = floor_seats[x].y;
                if (floor_seats[x].y < y_min) y_min = floor_seats[x].y;
            }
            if (last_index) {

                first_x = x_min - 1;
                first_y = y_min - 1;
            } else {

                first_x = x_min - 1;
                first_y = y_min - 1;
            }
            this.seedingSeatsLoop(floor_seats, first_x, first_y, floor);
        },
        seedingSeatsLoop(floor_seats, x, y, floor, last_index = null) {
            for (let seat in floor_seats) {
                this.seat_class = this.seat_class_update[floor_seats[seat].type];
                this.seedSeat(floor_seats[seat], ++seat, x, y, floor);
                if (!last_index) {
                    this.first_floor_last_index = seat;
                }
            }
        },
        seedSeat(seat, seat_index, x, y, floor) {
            let ix = seat.x - x;
            let iy = seat.y - y;
            if (this.booked_places && this.booked_place_class[this.booked_places[seat_index]]) {
                this.seat_class = this.booked_place_class[this.booked_places[seat_index]];
                if(this.seat_class === 'sold') {
                    if(this.men_places.includes(seat_index)) this.seat_class = 'sold-male'
                    if(this.women_places.includes(seat_index)) this.seat_class = 'sold-female'
                }
            }
            this.seats_from_db.push({x: ix, y: iy, color: this.seat_class, floor: floor, index: seat_index});
        },
        findSeat(x, y, floor, type) {
            return type.findIndex((item) => {
                return item.x === x && item.y === y && item.floor === floor;
            });
        },
        getColor(x, y, floor, type) {
            let col = type.find((item, index) => {
                return item.x === x && item.y === y && item.floor === floor;
            });
            return col !== undefined ? col.color : 'white';
        },
        process(places) {
            for (let x in places) {
                this.selectSeat(places[x], true);
            }
        },
        async selectSeat(place, update = false) {
            let checking_status = await this.isSeatOnProcess(place, update);
            if (this.selected_seats.length >= 1 && this.booking_settings.cashier_can_book_more_than_one === false) {
                let status = await this.removeSelectedPlaces(place);
                this.selected_seats.splice(index, 1);
                if (index === -1) {
                    this.selected_seats.push({
                        place: place,
                        baggage: null,
                        service: null,
                        privilege: null,
                        discount: null,
                        total_price: null,
                        tax: null,
                        service_amount: null,
                        service_price: null,
                        required_services_sum: this.required_services_sum,
                        privilegeComment: null,
                        personal_data: {
                            full_name: null,
                            pinfl: null,
                            passport_number: null,
                            birth_date: null,
                            citizenship: null,
                            address: null,
                            phone: null,
                            gender: null,
                            child: {
                                child_status: 0,
                                child_full_name: null,
                                child_kinder_passport: null,
                                child_birth_date: null,
                                parent_permission: false,
                            }
                        },
                    });
                } else {
                    this.selected_seats.splice(index, 1);
                }
                this.loading_states.seat_is_selecting = false;
                if (status === false) {
                    return;
                }
            }
            let index = this.findSelectedSeat(place);
            this.loading_states.seat_is_selecting = true;
            this.loading_states.seat_number = place;

            if (this.booked_places[place]) {
                this.loading_states.seat_is_selecting = false;
                return false;
            }

            if (update === false && checking_status) {
                $('#seatIsOnProcess').modal('show');
                this.loading_states.seat_is_selecting = false;
                return;
            }

            if (index === -1) {
                this.selected_seats.push({
                    place: place,
                    baggage: null,
                    service: null,
                    privilege: null,
                    discount: null,
                    total_price: null,
                    tax: null,
                    service_amount: null,
                    service_price: null,
                    required_services_sum: this.required_services_sum,
                    privilegeComment: null,
                    personal_data: {
                        full_name: null,
                        pinfl: null,
                        passport_number: null,
                        birth_date: null,
                        citizenship: null,
                        address: null,
                        phone: null,
                        gender: null,
                        child: {
                            child_status: 0,
                            child_full_name: null,
                            child_kinder_passport: null,
                            child_birth_date: null,
                            parent_permission: false,
                        }
                    },
                });
            } else {
                this.selected_seats.splice(index, 1);
            }
            this.loading_states.seat_is_selecting = false;
            this.checkSeats();
        },
        async isSeatOnProcess(seat_number, update) {
            let postData = {};
            postData.trip_id = this.trip_id;
            postData.seat_number = seat_number;
            postData.station_to = this.station_to;
            postData.station_from = this.station_from;
            postData.updateStatus = update;
            let status = false;
            await this.$api.post('cashier.is-seat-on-process', postData)
                .then(res => {
                    this.seat_is_on_process_details = res;
                    status = res.data.status;
                }).finally(() => {
                });
            return status;
        },
        checkSeats() {
            this.selected_seats.length > 0 ? this.book_button_disabled = false : this.book_button_disabled = true;
        },
        findSelectedSeat(place) {
            return this.selected_seats.findIndex((item) => {
                return item.place === place;
            });
        },
        selectedClass(place) {
            let col = this.selected_seats.find((item, index) => {
                return item.place === place;
            });
            return col !== undefined ? 'selected' : '';
        },
        async unsetPlace(place) {
            await this.isSeatOnProcess(place);
            let index = this.findSelectedSeat(place);
            this.selected_seats.splice(index, 1);
            this.checkSeats();
            this.removePrices(index);
        },
        calculatePrice(passenger) {

            let price = Math.round(this.details.trip_price);
            let required_service_sum = Math.round(this.required_services_sum);
            //price += (this.services.services.find(item => item.id === passenger.baggage) || {price: 0}).price;
            //price += (this.services_response.find(item => item.id === passenger.service) || {price: 0}).price;
            let baggage_price = (this.services.services.find(item => item.id === passenger.baggage) || {price: 0}).price;
            let services_price = (this.services_response.find(item => item.id === passenger.service) || {price: 0}).price;
            let percent = (this.privileges.find(item => item.id === passenger.privilege) || {percent: 100}).percent / 100;
            let ticket_paid = Math.round(price * percent);
            let discount = Math.round(price - price * percent);
            // `percent` is the fraction of the price the passenger PAYS (not the
            // discount). A privilege that pays 0% (i.e. gives a full, 100% discount
            // and the ticket is free) also waives the bus-station collection.
            // Any partial-discount privilege, or no privilege at all, keeps paying
            // the bus-station collection as before.
            let is_full_discount = percent === 0;
            // Privilege types 12 (asosiy imtiyozli yo‘lovchi) and 13 (hamroh) additionally
            // pay nothing for the chosen optional service. Every other privilege keeps
            // paying for it as before.
            let service_is_free = [12, 13].indexOf(parseInt(passenger.privilege, 10)) !== -1;
            let service_paid = service_is_free ? 0 : services_price;
            let required_paid = is_full_discount ? 0 : required_service_sum;
            discount += (services_price - service_paid) + (required_service_sum - required_paid);
            let index = this.findSelectedSeat(passenger.place);
            this.selected_seats[index].discount = discount;
            this.selected_seats[index].total_price = this.total_sum_for_payment;
            this.selected_seats[index].tax = is_full_discount ? 0 : Math.round(this.required_services_sum);
            this.selected_seats[index].service_price = services_price;
            let result = [];
            result['price'] = ticket_paid + required_paid + /*baggage_price +*/ service_paid + this.presale_settings.presale_fee_temp;

            if (this.ticket_type === 1 || this.isFromBooked) {
                result['price'] += this.booking_settings.booking_fee;
            }
            result['discount'] = Math.round(discount);

            return result;

        },
        modalShow(place) {
            this.clearErrors();
            this.passport_number_is_not_unique = false;
            this.modal_place_id = place;
            for (let x in this.selected_seats) {
                if (this.selected_seats[x].place === place) {
                    this.personal_data = this.selected_seats[x].personal_data;
                    if (this.personal_data.birth_date) {
                        this.passenger_birth_date = this.personal_data.birth_date;
                    }
                    if (this.personal_data.child.child_birth_date) {
                        this.child_birth_date = this.personal_data.child.child_birth_date;
                    }
                    break;
                }
            }
            $('#exampleModal').modal('show');
        },
        personalDataModalSave() {
            this.personal_data.passport_number = this.personal_data.passport_number ? this.personal_data.passport_number.replace(/_/g, '') : '';
            this.full_name_required = false;
            this.gender_required = false;

            if (!this.personal_data.gender) {
                this.gender_required = true;
                return;
            }
            for (let x in this.selected_seats) {
                if (this.selected_seats[x].place === this.modal_place_id) {
                    let passport = this.personal_data.passport_number;
                    let full_name = this.personal_data.full_name;

                    if (passport && !this.passport_numbers.numbers.includes(passport)) {

                        this.passport_numbers.numbers.push(passport);
                        this.passport_numbers.index.push(x);
                        this.personal_data = this.selected_seats[x].personal_data;
                        // this.personal_data.birth_date = this.passenger_birth_date;
                        // this.personal_data.child.child_birth_date = this.child_birth_date;

                    } else if (passport && !this.passport_numbers.index.includes(x) && this.passport_numbers.numbers.includes(passport)) {

                        this.passport_number_is_not_unique = true;
                        return;
                    }

                    if (this.details.trip_type === 1 && !full_name && !passport) {
                        this.full_name_required = true;
                        this.passport_number_is_not_unique = true;
                        return;
                    }

                    if (this.details.trip_type === 1 && !full_name) {
                        this.full_name_required = true;
                        return;
                    }

                    if (this.details.trip_type === 1 && !passport) {
                        this.passport_number_is_not_unique = true;
                        return;
                    }
                    break;
                }
            }
            this.passenger_birth_date = this.$moment().format("MM.DD.YYYY"),
                this.child_birth_date = this.$moment().format("MM.DD.YYYY"),
                $('#exampleModal').modal('hide');
            this.full_name_required = false;
            this.passport_number_is_not_unique = false;
        },
        personalDataModalClose() {
            this.full_name_required = false;
            this.passport_number_is_not_unique = false;
            this.gender_required = false;
            let index = this.findSelectedSeat(this.modal_place_id);
            this.personal_data.full_name = null;
            this.personal_data.passport_number = null;
            this.personal_data.address = null;
            this.personal_data.birth_date = null;
            this.personal_data.citizenship = null;
            this.personal_data.phone = null;
            this.personal_data.gender = null;
            this.passport_numbers.numbers.splice(index, 1);
            this.passport_numbers.index.splice(index, 1);
            //this.selected_seats[index] ? this.selected_seats[index].personal_data.splice(index,1) : '';
            $('#exampleModal').modal('hide');
        },
        bookedModalClose() {
            $('#placesBookedModal').modal('hide');
            $('#successfullyBooked').modal('hide');
            this.$router.go(0);
        },
        seatIsOnProcessClose() {
            $('#seatIsOnProcess').modal('hide');
        },
        resultSum() {
            this.returned_sum_for_payment = this.received_sum_for_payment - this.total_sum_for_payment;
            this.payment_button_disabled = this.returned_sum_for_payment < 0 || this.total_sum_for_payment === 0;
            if (this.total_sum_for_payment === 0) {
                this.payment_button_disabled = false;
            }
        },
        onlyForCurrency($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            // only allow number and one dot
            if ((keyCode < 48 || keyCode > 57) || $event.target.value.length > 8) { // 46 is dot
                $event.preventDefault();
            }

            // restrict to 2 decimal places
            if (this.price != null && this.price.indexOf(".") > -1 && (this.price.split('.')[1].length > 1)) {
                $event.preventDefault();
            }
        },
        removePrices(index) {
            this.received_sum_for_payment = null;
            this.returned_sum_for_payment = null;
            this.payment_button_disabled = true;
            this.selected_seats[index] && this.selected_seats[index].privilege !== null ? this.privilegeCommentsShow[index] = true : this.deletePrivilegeCommentsIndex(index);
        },
        openPrivilegeCheck(passenger, index) {
            this.$refs.privilegeCheckModal.open({
                preferredCheckId: passenger.privilege,
                pinfl: passenger.personal_data.pinfl,
                passportNumber: passenger.personal_data.passport_number,
                context: index,
            });
        },
        applyCheckedPinfl(payload) {
            const passenger = this.selected_seats[payload.context];
            if (!passenger) return;

            this.$set(passenger.personal_data, 'pinfl', payload.pinfl);
            this.$set(passenger.personal_data, 'passport_number', payload.passportNumber);
        },
        privilegeChanged(passenger, index) {
            this.removePrices(index);
        },
        deletePrivilegeCommentsIndex(index) {
            delete this.privilegeCommentsShow[index];
            this.$forceUpdate();
        },
        seatBooking() {

        },
        async booking(type) {
            this.payment_button_disabled = true;
            let seats = this.selected_seats;
            let total_price = 0;
            let total_tax = 0;
            let total_discount = 0;
            let total_service_amount = 0;

            for (let x in seats) {
                seats[x].total_amount = this.calculatePrice(seats[x]).price;
                total_tax = total_tax + seats[x].tax;
                total_discount = total_discount + seats[x].discount;
                total_service_amount = total_service_amount + seats[x].service_price;
            }

            this.form.total_price = this.total_sum_for_payment;
            this.form.service_amount = Math.round(total_service_amount);
            this.form.discount = Math.round(total_discount);
            this.form.tax = Math.round(total_tax);
            this.form.passengers = seats;
            this.form.trip_id = this.trip_id;
            this.form.booking_type = type;
            this.form.payment_type = parseInt(this.payment_type);
            this.form.station_from = this.station_from;
            this.form.station_to = this.station_to;

            if (!this.validateItems()) {
                this.loading_states.list = false;
                this.payment_button_disabled = false;
                return false;
            }

            //alx e-pos
            if (this.epos.enabled) {
                await this.getEposDeviceId();
                if (this.epos.device_id === null) {
                    this.loading_states.list = false;
                    this.payment_button_disabled = false;
                    return false;
                }

                let zstatus = await this.eposOpenZReport();
                if (zstatus === false) {
                    this.loading_states.list = false;
                    this.payment_button_disabled = false;
                    return false;
                }
            }

            this.form.submit('post', this.route('api.cashier.ticket-save'), false)
                .then(res => {
                    if (!res.errors) {
                        if (res.data.booked_places && res.data.booked_places.booked === true) {
                            this.already_booked_places = res.data.booked_places.place_numbers;
                            $('#placesBookedModal').modal('show');
                        } else if (res.data.result && res.data.result === true) {
                            if (res.data.booking_type === this.booking_type_successfully_payment) {
                                //this.$router.push('/cashier/qr-section/' + res.data.uuid);
                                //return false;

                                //alx e-pos
                                if (this.epos.enabled) {
                                    this.eposSale(res.data.uuid, res.data.order_id);
                                } else {
                                    this.$router.push('/cashier/qr-section/' + res.data.uuid);
                                    return false;
                                }

                            } else {
                                this.successfully_booked_order = res.data.order_id;
                                this.successfully_booked_passengers = res.data.passengers;
                                $('#successfullyBooked').modal('show');
                            }

                        } else if (!res.data.result && res.data.result === false && res.data.message) {
                            this.errorMsg(res.data.message);
                        }

                    } else {
                        this.errorMsg(res.errors)
                    }
                })
                .catch(errors => {
                    this.errorMsg(this.i18n('Data was not saved!') + "\n" + errors);
                })
                .finally(() => {
                    //alx e-pos
                    if (!this.epos.enabled) {
                        this.loading_states.list = false;
                        this.payment_button_disabled = false;
                    }
                });
        },

        //alx e-pos
        getEposData() {
            this.loading_states.epos = true;
            this.$api.get('epos.data').then(res => {
                if (res.data.enabled) {
                    this.epos.enabled = true;
                    this.epos.url = res.data.url;
                    this.epos.token = res.data.token;
                    this.epos.printer_size = res.data.printer_size;
                    this.epos.company_name = res.data.company_name;
                    this.epos.company_address = res.data.company_address;
                    this.epos.company_inn = res.data.company_inn;
                    this.epos.class_code_international = res.data.class_code_international;
                    this.epos.package_code_international = res.data.package_code_international;
                    this.epos.class_code_domestic = res.data.class_code_domestic;
                    this.epos.package_code_domestic = res.data.package_code_domestic;
                    this.epos.vat_percent = res.data.vat_percent;
                } else {
                    this.epos.enabled = false;
                }
            }).catch((err) => {
                this.errorMsg("E-POS: " + this.i18n('Error receiving data from the server!') + "\n" + err);
                this.$router.go(0);
            }).finally(() => {
                this.loading_states.epos = false;
            });
        },
        async getEposDeviceId() {
            let status = false;
            await this.$http.post(this.epos.url, {
                "token": this.epos.token,
                "method": "getDeviceId",
            }).then(res2 => {
                if (res2.data.error) {
                    if (res2.data.message) {
                        this.errorMsg("E-POS: " + res2.data.message);
                    }
                    this.epos.device_id = null;
                    status = false;
                } else {
                    console.log("E-POS: DeviceId: ", res2.data.message);
                    this.epos.device_id = res2.data.message;
                    status = true;
                }
            }).catch((err) => {
                this.errorMsg("E-POS: " + this.i18n('Unable to get DeviceId!') + "\n" + err);
                this.epos.device_id = null;
                status = false;
            }).finally(() => {

            });
            return status;
        },
        successMsg(message) {
            if (_.isArray(message)) {
                message.forEach(error => {
                    Vue.notify({
                        type: 'success',
                        group: 'foo',
                        title: '',
                        text: error.message
                    });
                })
            } else {
                Vue.notify({
                    type: 'success',
                    group: 'foo',
                    title: '',
                    text: message
                });
            }
        },
        async eposOpenZReport() {
            let status = false;
            let method = "openZreport";
            await this.$http.post(this.epos.url, {
                "token": this.epos.token,
                "method": method
            }).then(res2 => {
                if (res2.data.error) {
                    if (res2.data.message) {
                        // Unfortunately E-POS doesn't have a method to check the Z report status, so we have to use this workaround for now
                        // Do not show the err if already opened
                        if (res2.data.message.includes('ERROR_ZREPORT_IS_ALREADY_OPEN')) {
                            status = true;
                        } else {
                            this.errorMsg("E-POS: " + res2.data.message)
                            status = false;
                        }
                    }
                } else {
                    this.successMsg("E-POS: " + this.i18n('Z report opened successfully!'));
                    status = true;
                }
            }).catch((err) => {
                this.errorMsg("E-POS: " + this.i18n('Error opening Z report!') + "\n" + err);
                status = false;
            }).finally(() => {

            })
            return status;
        },

        eposSale(uuid, order_id) {

            let class_code = '10406003001000000';
            let package_code = '1508553';

            let class_code_transporter = this.details.trip_type ? '10107001004000002' : '10107001004000001';
            let package_code_transporter = this.details.trip_type ? '1202221' : '1202220';

            let owner_type = 2; // Product ownership type: 0-resale, 1-manufacturer, 2-service

            let commission_tin = this.details.trip_type ? this.details.transporter_inn : '200796104';
            let passengerQnt = parseInt(this.form.passengers.length)
            let amount = passengerQnt * 1000;

            let tax = parseInt(this.form.tax) * 100 // in tin;

            let full_price = parseInt(this.form.total_price) * 100;

            let full_price_wo_tax = full_price - tax;

            let price_transporter = (this.details.trip_type || (tax > 0 && this.station_from == '1')) ? full_price_wo_tax : full_price;
            let price_bus_station = (this.details.trip_type || (tax > 0 && this.station_from == '1')) ? tax : 0;

            let vat_percent_transporter = this.details.trip_type ? 0 : 12;
            let vat_transporter = this.details.trip_type ? 0 : Math.round(price_transporter * 12 / (12 + 100));

            let vat_percent_bus_station = 12;
            let vat_bus_station = (this.details.trip_type || (tax > 0 && this.station_from == '1')) ? Math.round((tax * 12 / (12 + 100))) : 0;

            console.log('trip_type', this.details.trip_type)
            console.log("commission_tin", commission_tin);
            console.log("tax", tax);
            console.log("full_price", full_price);
            console.log("full_price_wo_tax", full_price_wo_tax);
            console.log("price_transporter", price_transporter);
            console.log("price_bus_station", price_bus_station);
            console.log("vat_percent_transporter", vat_percent_transporter);
            console.log("vat_transporter", vat_transporter);


            let discount_transporter = 0; //this.form.discount * 100;
            let discount_bus_station = 0; //this.form.discount * 100;

            let note = this.details.routes_from + "-" + this.details.routes_to + " " + this.details.full_time;

            let eposData = {
                "token": this.epos.token,
                "method": "sale",
                "companyName": this.epos.company_name,
                "companyAddress": this.epos.company_address,
                "companyINN": this.epos.company_inn,
                "staffName": this.details.user.username, // Cashier Name
                "printerSize": this.epos.printer_size,
                "params": {
                    //"paycheckNumber": order_id,
                    //"clientName": "Khamidov Iskander",
                    "note": note,
                    "items": [
                        {
                            "name": this.details.trip_type ? this.i18n('International ticket') : this.i18n('Domestic ticket'),
                            "discount": discount_transporter,
                            "price": price_transporter,
                            "amount": amount,
                            "vatPercent": vat_percent_transporter,
                            "vat": vat_transporter,

                            "classCode": class_code_transporter,
                            "packageCode": package_code_transporter,
                            "ownerType": owner_type,
                            "commissionTIN": commission_tin
                        }
                    ],
                    "receivedCash": this.form.payment_type === 1 ? full_price : 0,
                    "receivedCard": this.form.payment_type === 2 ? full_price : 0,
                }
            }
            if (this.details.trip_type || (tax > 0 && this.station_from == '1')) {
                eposData.params.items[1] = {
                    "name": this.i18n('Bus station service'),
                    "discount": discount_bus_station,
                    "price": price_bus_station,
                    "amount": amount,
                    "vatPercent": vat_percent_bus_station,
                    "vat": vat_bus_station,
                    // "commissionTIN": this.epos.company_inn,
                    "classCode": class_code,
                    "packageCode": package_code,
                    "ownerType": owner_type
                }
            }
            console.log(JSON.stringify(eposData))
            this.$http.post(this.epos.url, eposData).then(res2 => {
                if (res2.data.error) {
                    if (res2.data.message) {
                        this.errorMsg("E-POS: " + res2.data.message);
                    }
                    // TODO: Cancel the ticket
                    // Proceed anyway
                    this.$router.push({
                        name: 'qr-section',
                        params: {
                            id: uuid,
                        }
                    });
                    return false;
                }
                //console.log(res2.data.info);

                this.form.order_id = order_id;
                this.form.epos['method'] = 0;
                this.form.epos['deviceId'] = this.epos.device_id;
                this.form.epos['terminalId'] = res2.data.info.terminalId;
                this.form.epos['receiptSeq'] = res2.data.info.receiptSeq;
                this.form.epos['fiscalSign'] = res2.data.info.fiscalSign;
                this.form.epos['dateTime'] = res2.data.info.dateTime;

                this.form.epos['eposData'] = eposData;

                this.form.submit('post', this.route('api.epos.save-receipt'), false)
                    .then(res => {
                        if (res.errors) {
                            this.errorMsg(res.errors);
                        }
                        this.$router.push({
                            name: 'qr-section',
                            params: {
                                id: uuid,
                                epos: "epos"
                            }
                        });
                    })
                    .catch(errors => {
                        this.errorMsg("E-POS: " + this.i18n('Unable to save the receipt on the server!') + "\n" + errors)
                    })
                    .finally(() => {
                    });

                return true;
            }).catch((err) => {
                this.errorMsg("E-POS: " + this.i18n('Error paying the receipt!') + "\n" + err);
                // TODO: Cancel the ticket
                // Proceed anyway
                this.$router.push({
                    name: 'qr-section',
                    params: {
                        id: uuid,
                    }
                });

            }).finally(() => {
                this.loading_states.list = false;
                this.payment_button_disabled = false;
            })
        },

        childModalOpen(place) {
            let index = this.findSelectedSeat(place);
            this.child_modal_place = place;
            let child_model = this.selected_seats[index].personal_data.child;
            this.personal_data.child.child_kinder_passport = child_model.child_kinder_passport;
            this.personal_data.child.parent_permission = child_model.parent_permission;
            this.personal_data.child.child_birth_date = child_model.child_birth_date;
            this.personal_data.child.child_full_name = child_model.child_full_name;
            $('#childModal').modal('show');
        },
        childModalClose() {
            let index = this.findSelectedSeat(this.child_modal_place);
            let child_model = this.selected_seats[index].personal_data.child;
            let temporary_child = this.personal_data.child;
            child_model.child_full_name = temporary_child.child_full_name;
            child_model.child_kinder_passport = temporary_child.child_kinder_passport;
            child_model.parent_permission = temporary_child.parent_permission;
            child_model.child_birth_date = temporary_child.child_birth_date;
            if (child_model.child_full_name && child_model.parent_permission && child_model.child_kinder_passport) {
                child_model.child_status = 1;
                $('#childModal').modal('hide');
            }
        },
        cancelChildModal() {
            let index = this.findSelectedSeat(this.child_modal_place);
            let child_model = this.selected_seats[index].personal_data.child;
            child_model.child_status = 0;
            child_model.child_full_name = '';
            child_model.child_kinder_passport = '';
            child_model.parent_permission = 0;
            child_model.child_birth_date = '';
            $('#childModal').modal('hide');
        },
        clearErrors() {
            this.form.errors.errors = null;
        },
        bookingClicked() {
            if (this.selected_seats.length > 1 && this.booking_settings.cashier_can_book_more_than_one_server === 0) {
                alert(this.i18n('Only one seat can be selected!'));
                this.ticket_type = 2;
            }
        },
        async removeSelectedPlaces(place) {
            this.seat_is_on_process_ajax_call_status = true;
            let postData = {};
            postData.trip_id = this.trip_id;
            postData.seat_number = place;
            let status = false;
            await this.$api.post('cashier.remove-selected-places', postData)
                .then(res => {
                    status = res.data;
                }).finally(() => {
                    this.seat_is_on_process_ajax_call_status = false;
                });
            return status;
        },
        validateItems() {

            let res = true;

            try {
                this.validatePrivilegeCompanionRules();
            } catch (error) {
                this.errorMsg(error);
                return false;
            }

            /* validate passangers personal data*/
            for (let x in this.form.passengers) {
                try {
                    this.validatePersonalData(this.form.passengers[x]);
                    this.validateChildItems(this.form.passengers[x]);
                    this.validateTicketInfo(this.form.passengers[x]);
                } catch (error) {
                    this.errorMsg(this.i18n('Passenger number') + " " + (x * 1 + 1) + ": " + error);
                    return false;
                }

            }
            /* validate passangers personal data*/

            return true;
        },
        validatePrivilegeCompanionRules() {
            const privilegeIds = this.form.passengers.map(passenger => Number(passenger.privilege));
            const beneficiaryCount = privilegeIds.filter(id => id === 12).length;
            const companionCount = privilegeIds.filter(id => id === 13).length;

            if (companionCount > 0 && beneficiaryCount !== 1) {
                throw this.i18n('A companion requires exactly one primary privileged passenger in the order')
            }

            if (companionCount > 1) {
                throw this.i18n('Only one companion is allowed for a primary privileged passenger')
            }
        },
        validateTicketInfo(passenger) {
            if (this.form.booking_type === this.booking_type_successfully_payment
                && [12, 13].includes(Number(passenger.privilege))
                && !/^\d{14}$/.test(passenger.personal_data.pinfl || '')) {
                throw this.i18n('PINFL is required for a privilege ticket')
            }

            return true;
        },
        validatePersonalData(passenger) {
            if (!passenger.personal_data.full_name) {
                throw this.i18n('Full name is required')
            }

            // if (!passenger.personal_data.gender) {
            //     throw this.i18n('Gender is required')
            // }

            if (
                (this.trip_type === 1 && !passenger.personal_data.full_name)
                || (this.trip_type === 1 && !passenger.personal_data.address)
                || (this.trip_type === 1 && !passenger.personal_data.phone)
                || (this.trip_type === 1 && !passenger.personal_data.passport_number)
                || (this.trip_type === 1 && !passenger.personal_data.citizenship)
            ) {
                throw this.i18n('All passenger data is required for international trips')
            }

            if ((this.trip_type === 1 && passenger.personal_data.child.child_status === 1 && !passenger.personal_data.child.child_kinder_passport)
                || (this.trip_type === 1 && passenger.personal_data.child.child_status === 1 && !passenger.personal_data.child.child_full_name)
                || (this.trip_type === 1 && passenger.personal_data.child.child_status === 1 && !passenger.personal_data.child.parent_permission)
            ) {
                console.log(passenger.personal_data.child.child_status);
                throw this.i18n('All passenger and child data is required for international trips')
            }

            if (!this.checkWordByLatin(passenger.personal_data.full_name)) {
                throw this.i18n('Full name must contain only Latin letters')
            }

            if (!this.validatePassportNumber(passenger.personal_data.passport_number)) {
                throw this.i18n('Passport details are invalid')
            }


        },
        validatePayment() {

            return true;
        },
        validatePassportNumber(number) {
            return true;
            if (!number) {
                return true;
            }

            let reg = /[A-Z]{2}\d{7}/
            if (number.match(reg) === null) {
                return false;
            }

            return number.match(reg)
        },
        validateChildItems(passenger) {
            if (!passenger.personal_data.child) {

                return;
            }

            console.log(passenger.personal_data.child.child_full_name)

            if (!passenger.personal_data.child.child_full_name) {
                return;
            }

            if (!this.checkWordByLatin(passenger.personal_data.child.child_full_name)) {
                throw this.i18n("Child's full name must contain only Latin letters")
            }
        },
        checkWordByLatin(word) {
            let reg = /^[A-Za-z\s\']*$/ig
            return word.match(reg);
        },
        errorMsg(message) {
            if (_.isArray(message)) {
                message.forEach(error => {
                    Vue.notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: error.message,
                        duration: -1,
                    });
                })
            } else {
                Vue.notify({
                    type: 'error',
                    group: 'foo',
                    title: '',
                    text: message,
                    duration: -1,
                });
            }
        },
        formatDuration(value) {
            if (!(value > 0)) {
                return '00:00:00';
            }

            const pad = number => number < 10 ? '0' + number : String(number);
            const hour = parseInt(value / 3600);
            const minute = parseInt((value % 3600) / 60);
            const second = parseInt(value % 60);

            return pad(hour) + ':' + pad(minute) + ':' + pad(second);
        },
        localizedName(item) {
            const language = this.$store.state.currentLang;
            const field = language === 'uz' ? 'name_uz' : language === 'en' ? 'name_en' : 'name';

            return item[field] || item.name || item.name_uz || item.name_en || '';
        },
    },
    computed: {
        currentUserRole() {
            const roleKeys = {
                1: 'User',
                2: 'Driver',
                3: 'Cashier',
                4: 'Conductor',
            };

            return roleKeys[this.details.user.user_type]
                ? this.i18n(roleKeys[this.details.user.user_type])
                : this.details.user.user_role;
        },
        countryNameField() {
            const language = this.$store.state.currentLang;
            return language === 'uz' ? 'name_uz' : language === 'en' ? 'name_en' : 'name';
        },
        datepickerLanguage() {
            return this.$store.state.currentLang === 'ru' ? 'ru' : 'en';
        },
        totalPrice() {
            let sum = 0;
            this.selected_seats.forEach(item => sum += this.calculatePrice(item)['price']);
            this.total_sum_for_payment = sum;
            return sum;
        },
        leftSeconds: function () {
            if (this.reserved_seconds > 0) {
                return this.formatDuration(this.reserved_seconds);
            }
        },
    },
    watch: {
        tripSeconds: function (val) {
            if (val <= 300) {
                this.alertFinishing = true;
            }
        },
        reserved_seconds: function (val) {
            if (val === 0) {
                clearInterval(this.interval);
                this.getOrderedPlacesFromStore();
                this.getBookedPlaces();
            }
        },
        ticket_type: function (n, o) {
            if (n !== o) {
                this.booking_settings.booking_fee = this.ticket_type === 1 ? this.booking_settings.booking_fee_server : this.ticket_type === 2 && this.reserved_seconds > 24 * 3600 ? res.data.booking_fee : 0;
                this.booking_settings.cashier_can_book_more_than_one = this.ticket_type === 1 && this.booking_settings.cashier_can_book_more_than_one_server === 0 ? false : this.booking_settings.cashier_can_book_more_than_one = true;
            }
        },
        personal_data() {
            if (!this.personal_data.citizenship) {
                this.personal_data.citizenship = 204;
            }
        },

    }
}
